import { render, staticRenderFns } from "./GlobalChapterSettings.vue?vue&type=template&id=3f8122cc&scoped=true&"
import script from "./GlobalChapterSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalChapterSettings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalChapterSettings.vue?vue&type=style&index=0&id=3f8122cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8122cc",
  null
  
)

export default component.exports